import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ConnectAdsAccountButton } from '../components/ConnectAdsAccountButton';
import { UserContext } from '../contexts/UserContext';

export default function Onboard() {
  const navigate = useNavigate();
  const { selectedAccount } = useContext(UserContext);

  useEffect(() => {
    if (
      selectedAccount &&
      selectedAccount.data().onboardStatus !== 'incomplete'
    ) {
      navigate('..');
    }
  }, [navigate, selectedAccount]);

  return (
    <>
      <div className="flex h-full w-full flex-col">
        <div className="flex flex-col gap-4 bg-white">
          <div className="flex flex-col items-stretch sm:flex-row sm:items-center">
            <div className="flex h-12 w-full flex-row items-center justify-between gap-2 border-b border-gray-300 pb-3">
              <h1 className="w-full grow text-2xl font-semibold leading-6 text-gray-900">
                Connect Ad Accounts
              </h1>
            </div>
          </div>
        </div>
        <div className="flex h-screen flex-row items-center justify-center">
          <ConnectAdsAccountButton />
        </div>
      </div>
    </>
  );
}
